// Required terms checkbox in the cart (snippets/wrb-terms-checkbox.liquid). The store isn't on Shopify Plus,
// so the checkout can't host it; instead the cart blocks every way into checkout until it's checked:
// the checkout button (click, or Enter inside the cart form) and the accelerated checkout buttons.
// Capture-phase listeners run before Horizon's own handlers and survive cart re-renders.

const isUnaccepted = (ctas) => {
  const input = ctas?.querySelector('.wrb-terms__input');
  return Boolean(input && !input.checked);
};

function block(event, ctas) {
  event.preventDefault();
  event.stopImmediatePropagation();
  ctas.querySelector('.wrb-terms__error')?.removeAttribute('hidden');
  ctas.querySelector('.wrb-terms__input')?.focus();
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('[name="checkout"], .additional-checkout-buttons')) return;
    const ctas = target.closest('.cart__ctas');
    if (isUnaccepted(ctas)) block(event, ctas);
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout') return;
    const ctas = submitter.closest('.cart__ctas');
    if (isUnaccepted(ctas)) block(event, ctas);
  },
  true
);

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('.wrb-terms__input')) return;
  if (input.checked) input.closest('.wrb-terms')?.querySelector('.wrb-terms__error')?.setAttribute('hidden', '');
});
